import styled from 'styled-components';

import { Text } from '../../Text/Text';

export const Placeholder = styled(Text)`
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
